import LoginForm from "../components/LoginForm"
import FingerprintTest from "../components/FingerprintTest"
import "../styles/LoginPage.css"
import { Navigate } from "react-router-dom"
import { UserContext } from "../context"
import { useContext } from "react"


const LoginPage = () => {
    const { userPayload } = useContext(UserContext)
    const { isAuth } = userPayload
    if (isAuth) {
        return <Navigate to='/map' />
    }
    return (
        <div className="login__container">
            <LoginForm />
            {/* <FingerprintTest /> */}
        </div>
    )
}

export default LoginPage